<template>
  <v-card elevation="0" width="100%">
    <v-dialog v-model="dialog" max-width="500">
      <Confirm
          title="Salvar"
          message="Tem certeza de que deseja salvar estes dados?"
          buttonText="Salvar"
          @cancel="dialog = false"
          @action="submit"
      />
    </v-dialog>

    <v-form ref="withdrawalOrderGuidelines">
      <v-row class="ma-0">
        <v-col cols="12" sm="12" md="12" lg="12">
          <label class="ml-1 mb-2 label-details">Quantos dias após aprovação do pagamento pode retirar o pedido</label>
          <v-text-field
              :disabled="user.type === 0"
              style="border: 1px solid #979797; border-radius: 7.5px"
              color="black"
              v-mask="'###'"
              background-color="#F5F5F5"
              outlined
              :rules="[rules.required, rules.minDays]"
              hide-details
              required
              v-model="daysToWithdrawProduct"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row class="ma-0">
        <v-col cols="12" sm="12" md="12" lg="12">
          <label class="ml-1 mb-2 label-details">Detalhes para retirar produtos</label>
          <v-textarea
              style="border: 1px solid #979797; border-radius: 7.5px"
              color="black"
              background-color="#F5F5F5"
              outlined
              hide-details
              v-model="detailsWithdrawProduct"
              rows="5"
              :rules="[rules.required]"
              placeholder="Detalhes para retirar produtos"
          ></v-textarea>
        </v-col>
      </v-row>

      <v-row class="pb-3" justify="center">
        <v-col cols="12" md="6">
          <v-btn
              class="primary-button"
              color="normalred"
              elevation="0"
              @click="validate()"
              block
          >
            Salvar
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </v-card>
</template>

<script>
import ApiService from "../../../../services/ApiService";
import Vue from "vue";
import Confirm from "../../components/ConfirmExit.vue";
import {VMoney} from "v-money";

export default {
  name: "WithdrawalOrderGuidelines",
  components: {
    Confirm,
  },
  props: {},
  data: () => ({
    outlined: true,
    optionsPercentagem: {
      locale: "pt-BR",
      suffix: "",
      prefix: "%",
      length: 11,
      precision: 2,
      min: 10,
      max: 10
    },
    user: {},
    apiService: new ApiService(),
    dialog: false,
    detailsWithdrawProduct: '',
    daysToWithdrawProduct: 0,
    currentUser: {},
    rules: {
      required: (value) => !!value || "Campo requerido.",
      minDays: (v) => v > 0 || "Minimo 1 dia.",
    },
  }),
  async created() {
    this.user = JSON.parse(localStorage.getItem("user"));
    await this.getPlatformSettings();
  },
  methods: {
    async getPlatformSettings() {
      try {
        await this.apiService.get(`resale/get-one?id=${this.user.id}`).then((response) => {
          this.currentUser = response
          this.detailsWithdrawProduct = response.detailsWithdrawProduct;
          this.daysToWithdrawProduct = response.daysToWithdrawProduct;
        });
      } catch (e) {
      }
    },
    validate() {
      if (!this.$refs.withdrawalOrderGuidelines.validate()) {
        Vue.$globalEvent.$emit("onFlashMessage", {
          type: "error",
          title: "",
          message: "Digite o valor do frete padrão das revendas",
          trace: null,
        });
        return
      }
      this.dialog = true;
    },
    async submit() {
      try {
        const model = {
          ResaleId: this.currentUser.id,
          DetailsWithdrawProduct: this.detailsWithdrawProduct,
          DaysToWithdrawProduct: this.daysToWithdrawProduct,
        };
        this.apiService.put(`resale/details-withdraw-product`, model)
            .then((resp) => {
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "success",
                title: "Porcentagem",
                message: resp.message,
                trace: null,
              });

              this.dialog = false;
              this.loading = false;
            })
            .catch((err) => {
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "error",
                title: "Erro",
                message: err.body.message,
                trace: null,
              });
              this.dialog = false;
              this.loading = false;
            });
      } catch (e) {

      }
    },
  },
};
</script>
<style scoped>
</style>
